import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
//import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Selectsearch from "react-select"
import "react-datepicker/dist/react-datepicker.css";
import PageTemplate from "Routes/pdfTemplate";
import { NotificationManager } from 'react-notifications';

import {
	FormGroup,
	Label,
    Input
} from 'reactstrap';

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import Mainvisual from './visualcomponent/mainvisual';

import {  
  
   allSCVisualisation,
   scVisualisationDetails
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

class scvisualisation extends Component {
   
    constructor(props) {
      
        super(props);
        this.state = {
            
            
            viewdiv:true,
            repeatHeaders:true,
            succdiv:false,
            errordiv:false,
            visualdiv:false,
            selyear:'',
            selassessment:'',
            
        };      
         
        this.selectorRef = React.createRef(null);
         this.onBackSection = this.onBackSection.bind(this);  
         this.backSection = this.backSection.bind(this);  
    }

    UNSAFE_componentWillMount() {
        var stdrole=localStorage.getItem('stdrole');
        if(stdrole==1){
            var studid=localStorage.getItem('user_id');
        }else{
            var studid='';
        }
        this.props.allSCVisualisation(studid);
	}

    onBackSection() {
		this.setState({ adddiv:false,
         editdiv:false,
         viewdiv:true });
	}

   
    
    addHandleReport(assmntval){
        var student = assmntval.mv_studentID;
        var selyear = assmntval.mv_year;
        var commaSep = assmntval.mv_quaters;
        var oid = assmntval.mvID;

        var spltyear=selyear.split(',');
        var spltassmt=commaSep.split(',');
        
        this.props.scVisualisationDetails(student, selyear, commaSep, oid).then((data) => {   
                
            if(data.status==1){
                this.setState({ 
                    viewdiv:false,
                    visualdiv:true,
                 });
            }
        });
        
        
    }

    calculate_age = (dob1) => {
        var today = new Date();
        var birthDate = new Date(dob1); 
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
        {
            age_now--;
        }
        return age_now;
    }

    exportPDFWithMethod = () => {
        this.selectorRef.current.save();
    }

    backSection(){
        this.setState({ 
            student: '',
            selyear:'',
            selassessment:'',  
            visualid:'',   
            maindiv:false,
            viewdiv:true,
            creatediv:false,
            visualdiv:false
         });    
    }

   

    render() {
      const { match, scvisualisationlist, loading } = this.props;       

    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "No" },
        { name: "name", label: "Name" },
        { name: "year", label: "Year" },
        { name: "assessment", label: "Assessment No" },
        { name: "date", label: "Date" },
        { name: "action", label: "Action" }
    ];

    const tabledata=scvisualisationlist.map((assmntval,idx) => {  

            const ebtn=<MatButton variant="contained" className="btn-icon btn-twitter mr-15 mb-10 text-white" onClick={ ()=>this.addHandleReport(assmntval)}> <i className="zmdi zmdi-file-text"></i> View</MatButton>;
            

            return {
                no:idx+1,
                name: assmntval.student,
                year: assmntval.mv_year,
                assessment: assmntval.mv_quaters,
                date: assmntval.crdate,
                action: ebtn
            }
    });        
      
        const styles = {
            table: {
                border: "2px solid rgb(0, 0, 0)",
                borderColor:"rgb(0 0 0 / 49%)",
                borderStyle:"solid"
            },
            tabletrtd: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px"
            },
            errmessage:{
                textAlign:"center",
                color:"red"
            }
        };
     
    
       return (
          
                <div className="row">   
                
                {this.state.viewdiv && 
                    <div className="col-sm-12 col-md-12">
                        <div className="col-md-10" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="Report List" fullBlock>
                            <MUIDataTable
                                data={tabledata}
                                columns={columns}
                                options={options} 
                            />   
                        </RctCollapsibleCard>
                        </div>
                    </div>  
                }                

                {this.state.visualdiv &&
                  
                    <div className="col-md-8" style={{margin:"0 auto"}}>
                             <Mainvisual onClick={this.backSection} data={this.state} />   
                    </div>
                  
                
                }

                </div>             
             
         
       )
    }
 }


const mapStateToProps = ({scvisualisation}) => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
	const { scvisualisationlist, loading } = scvisualisation;
	return {scvisualisationlist, loading};
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
}

export default connect(mapStateToProps, {   
    scVisualisationDetails,
    allSCVisualisation
})(scvisualisation); 